import { z } from "zod";

import { constantsData } from "@/data";

export const profilePasswordFormSchema = z.object({
    confirmPassword: z.string().min(
        6,
        { message: constantsData.msgs.minPassword },
    ),
    newPassword: z.string().min(
        6,
        { message: constantsData.msgs.minPassword },
    ),
    oldPassword: z.string().min(
        1,
        { message: constantsData.msgs.requiredField },
    ),
}).superRefine(({
    confirmPassword,
    newPassword,
}, ctx) => {
    if (confirmPassword !== newPassword) {
        ctx.addIssue({
            code: "custom",
            message: constantsData.msgs.passwordNotMatch,
            path: ["confirmPassword"],
        });
    }
});
